import { Config } from '@leverege/plugin';
import { constants } from '../../attributes/CalculatedAlerts';
import CalculatedAlertsEqualsComparator from './CalculatedAlertsEqualsComparator';
import AliasEqualsSelector from '../AliasEqualsSelector';
const options = () => [{
  name: 'Theft Recovery Activated',
  value: constants.THEFT_RECOVERY_ACTIVATED
}, {
  name: 'Theft Recovery Activating',
  value: constants.THEFT_RECOVERY_ACTIVATING
}, {
  name: 'Theft Recovery Ending',
  value: constants.THEFT_RECOVERY_ENDING
}, {
  name: Config.get('PendingSaleMessage', 'label', 'Sale Pending. Unpair Locator'),
  value: constants.REMOVE_PENDING_SALE
}, {
  name: 'Sale Pending. Replace Locator',
  value: constants.REPLACE_PENDING_SALE
}, {
  name: 'Sale Pending. Add Locator',
  value: constants.ADD_PENDING_SALE
}, {
  name: 'Position Pending',
  value: constants.POSITION_PENDING
}, {
  name: 'Suspected Drive Off',
  value: constants.SUSPECTED_DRIVE_OFF
}, {
  name: 'Suspected Off Lot',
  value: constants.SUSPECTED_OFF_LOT
}, {
  name: 'Pending Automatic Location Transfer',
  value: constants.PENDING_AUTOMATIC_LOCATION_TRANSFER
}, {
  name: 'Device Health Problem',
  value: constants.DEVICE_HEALTH
}, {
  name: 'End of Life',
  value: constants.END_OF_LIFE
}, {
  name: 'Not Reporting',
  value: constants.NOT_REPORTING
}, {
  name: 'Not Operational',
  value: constants.NON_OPERATIONAL
}, {
  name: 'Sold with Low Battery',
  value: constants.SOLD_LOW_BATTERY
}, {
  name: 'Sold Offline',
  value: constants.SOLD_OFFLINE
}].sort((a, b) => a.name.localeCompare(b.name));
export default AliasEqualsSelector.create(CalculatedAlertsEqualsComparator, options);